import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/site/Navbar";
import Footer from "@/site/Footer";

export default function SiteLayout() {
  const [content, setContent] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    let mounted = true;
    api.get("/site/content")
      .then(({ data }) => { if (mounted) setContent(data || {}); })
      .catch(() => { if (mounted) setContent((c) => c || {}); });
    // Never leave visitors on a blank spinner; render defaults, then upgrade when content arrives.
    const t = setTimeout(() => { if (mounted) setContent((c) => c || {}); }, 2500);
    return () => { mounted = false; clearTimeout(t); };
  }, []);
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" }); }, [pathname]);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="h-8 w-8 rounded-full border-2 border-[var(--rgh-primary)] border-t-transparent animate-spin" />
      </div>
    );
  }

  return (
    <div className="rgh-site min-h-screen bg-white text-[#0A0A0A] antialiased">
      <Navbar content={content} />
      <main><Outlet context={content} /></main>
      <Footer content={content} />
    </div>
  );
}
